var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:"caller-audio",attrs:{"id":"caller-audio"}}),_c('audio',{ref:"test-caller-audio",attrs:{"id":"test-caller-audio","src":require('@/assets/audio/sounds/caller-audio-test.mp3')}})])}
var staticRenderFns = []

export { render, staticRenderFns }